export const color = {
	primary: '#f1c71d',
	secondary: '#ffffff',
	tertiary: '#ffffff',
	headerLogo: '#43484D',

	blackOne: '#000',
	blackTwo: '#43484D',

	buttonNextBgColor: '#f1c71d',
	buttonNextTextColor: '#000',
	buttonNextMobileBgColor: '#f1c71d',
	buttonNextMobileTextColor: '#000',
	buttonNextBorderColor: '#fff',
	buttonNextMobileBorderColor: '#f1c71d',
	buttonNextHoverBgColor: '#f1c71d',
	buttonNextHoverTextColor: '#fff',
	buttonNextHoverBorderColor: '#f1c71d',

	buttonBackBgColor: '#fff',
	buttonBackTextColor: '#000',
	buttonBackMobileBgColor: '#f1c71d',
	buttonBackMobileTextColor: '#000',
	buttonBackBorderColor: '#f1c71d',
	buttonBackMobileBorderColor: '#000',
	buttonBackHoverBgColor: '#f1c71d',
	buttonBackHoverTextColor: '#000',
	buttonBackHoverBorderColor: '#f1c71d',

	exchangeSelectBtnTextColor: '#ffffff',
	exchangeSelectBtnBgColor: '#f1c71d',
	exchangeSelectBtnBorderColor: '#f1c71d',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#ffffff',

	exchangeDontSelectBtnTextColor: '#ffffff',
	exchangeDontSelectBtnBgColor: '#000000',
	exchangeDontSelectBtnBorderColor: '#000000',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#ffffff',

	exchangeRemoveSelectBtnTextColor: '#ffffff',
	exchangeRemoveSelectBtnBgColor: '#000000',
	exchangeRemoveSelectBtnBorderColor: '#000000',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#ffffff',

	flowButtonSelectedTextColor: '#ffffff',
	flowButtonSelectedBgColor: '#000000',
	flowButtonSelectedBorderColor: '#000000',

	flowButtonOriginalTextColor: '#000000',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#000000',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
